import { NoComment as NoComment_filmzi } from './NoComment.filmzi';
import { NoComment as NoComment_kojaro } from './NoComment.kojaro';
import { NoComment as NoComment_pedal } from './NoComment.pedal';
import { NoComment as NoComment_zoomg } from './NoComment.zoomg';
import { NoComment as NoComment_zoomit } from './NoComment.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_TENANT) {
    case 'filmzi':
      return NoComment_filmzi;

    case 'kojaro':
      return NoComment_kojaro;

    case 'pedal':
      return NoComment_pedal;

    case 'zoomg':
      return NoComment_zoomg;

    default:
      return NoComment_zoomit;
  }
};

export const NoComment = IconRenderer();
